jQuery( document ).ready(function($) {
    $('.box-text').matchHeight({byRow: true, property: 'height', target: null, remove: false});
    $('.match-height').matchHeight({byRow: true, property: 'height', target: null, remove: false});
    $('.blog-header').matchHeight({byRow: true, property: 'height', target: null, remove: false});
    $('.service-title').matchHeight({byRow: true, property: 'height', target: null, remove: false});
    $('.service-text').matchHeight({byRow: true, property: 'height', target: null, remove: false});

    gsap.registerPlugin(ScrollTrigger);

    gsap.utils.toArray(".fadein").forEach(fadein => {
        gsap.set(fadein, {
            opacity: 0
        });
        var tl = gsap.timeline({
            scrollTrigger: {
                trigger: fadein,
                start: "top 70%",
                end: "bottom 20%"
            }
        });

        tl.to(fadein, {
            duration: 1.5,
            opacity: 1
        });
    });

    const scrollElements = gsap.utils.toArray('.fadeInList');
    scrollElements.forEach(element => {
        gsap.set(element, {
            opacity: 0,
            x: -10
        });

        element.anim = gsap.to(element, {
            duration: 0.5,
            paused: true,
            opacity: 1,
            x: 0
        });
    });

    function staggerPlayBatch(batch) {
        gsap.to(batch, { stagger: {
            each: 0.5,
            onStart: function() { this.targets()[0].anim.play() }
        }})
    }

    ScrollTrigger.batch(scrollElements, {
        onEnter: staggerPlayBatch
    });

   /* var myElement = document.querySelector("header");
    // construct an instance of Headroom, passing the element
    var headroom  = new Headroom(myElement);
    // initialise
    headroom.init();*/

   /* $('.slick-hero').slick({
            infinite: true,
            dots: false,
            arrows: false,
            fade: true,
            autoplay: true,
            swipe: true,
            touchMove: true,
            centerMode: false,
            variableWidth: false,
            adaptiveHeight: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 2000,
            autoplaySpeed: 4000
        }
    );

    $('.slick-testimonials').slick({
            infinite: true,
            dots: false,
            arrows: false,
            fade: true,
            autoplay: true,
            swipe: true,
            touchMove: true,
            centerMode: false,
            variableWidth: false,
            adaptiveHeight: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            speed: 3000,
            autoplaySpeed: 4000
        }
    );*/

    new Readmore('.quote', {
        speed: 75,
        collapsedHeight: 100,
        lessLink: '<a href="#">Read less</a>'
    });

})